import { useQuery } from '@hooks/reactQuery';

import { getPortalTasksAssigneesForFilter } from '@api/portalTasks';

import { extractQueryParams } from '@utils/common';
import { projectUsersFormatted } from '@utils/formatter';

import { TNameTitleValueLabel } from '@interfaces/common/common';

import { refetchOptions } from '@constants/common';
import { PORTAL_TASKS_ASSIGNEES_FILTER } from '@constants/queryKeys';

interface IUseQueryPortalTasksAssigneesFilterReturned {
	portalTasksAssigneesFilter: TNameTitleValueLabel[];
	isLoadingPortalTasksAssigneesFilter: boolean;
}

export const useQueryPortalTasksAssigneesFilter = (projectId?: string): IUseQueryPortalTasksAssigneesFilterReturned => {
	const {
		data,
		isLoading,
		isFetching,
	} = useQuery({
		queryKey: [PORTAL_TASKS_ASSIGNEES_FILTER, projectId],
		queryFn: extractQueryParams(getPortalTasksAssigneesForFilter),
		select: requestTypes => projectUsersFormatted(requestTypes),
		enabled: [!!projectId],
		...refetchOptions,
	});

	return {
		portalTasksAssigneesFilter: data || [],
		isLoadingPortalTasksAssigneesFilter: isLoading || isFetching,
	};
};
